import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  position: relative;
  width: 100%;
  margin-top: -10px;

  > * {
    width: 100%;
  }
`;

export const ApplePayWrapper = styled('div')`
  position: static;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  gap: 0.5em;
  width: 100%;
  height: 44px;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  padding: 0;
  border-radius: 23px;
  box-sizing: border-box;
  opacity: 1;
`;

export const GooglePayWrapper = styled('div')`
  position: static;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  gap: 0.5em;
  width: 100%;
  height: 44px;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  padding: 0;
  border-radius: 23px;
  box-sizing: border-box;
  opacity: 1;
`;

export const InvisibleGooglePay = styled('div')`
  display: none;
`;

export const InvisiblePix = styled('div')`
  display: none;
`;

export const InvisiblePixQr = styled('div')`
  display: none;
`;

export const PixWrapper = styled('div')`
  position: static;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  gap: 0.5em;
  width: 100%;
  height: 44px;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  padding: 0;
  border-radius: 23px;
  box-sizing: border-box;
  opacity: 1;
`;
